var map = {
	"./DSC_3906.webp": 63209,
	"./DSC_3912.webp": 60861,
	"./DSC_3914.webp": 28304,
	"./DSC_3917.webp": 72982,
	"./DSC_3919.webp": 56717,
	"./DSC_3920.webp": 32826,
	"./DSC_3924.webp": 87083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54741;